export const TAG_CATEGORIES = {
  CAT_CONTACTS: 1,
  CAT_COMMUNICATIONS: 2
}

export const TAG_CATEGORIES_VALUES = [
  TAG_CATEGORIES.CAT_CONTACTS,
  TAG_CATEGORIES.CAT_COMMUNICATIONS
]
